<div class="container-fluid">
  <form class="row" [formGroup]="cartForm" (ngSubmit)="addItemToCart()">
    <div class="col-md-12 px-0">
      <div class="section-padding">
        <div class="text-right">
          <img
            src="/assets/icons/close-sheet.svg"
            class="mb-2"
            (click)="closeBottomSheet()"
            alt="close"
          />
        </div>

        <div
          *ngIf="isLoading"
          class="w-100 d-flex justify-content-center align-items-center text-center"
        >
          <i class="fa fa-spinner text-dark fa-3x spin"></i>
        </div>

        <div *ngIf="!isLoading" class="sheet-img-container">
          <img
            *ngIf="!isImageValid(extraMealDetails?.imageUrl)"
            src="/assets/images/no-food-img.svg"
            alt=""
            class="mb-4"
          />
          <img
            *ngIf="isImageValid(extraMealDetails?.imageUrl)"
            [src]="extraMealDetails?.imageUrl"
            alt=""
            class="mb-4"
          />
        </div>

        <h5 class="f-18 secondary-font-bold mb-2">
          {{ extraMealDetails?.name }}
        </h5>

        <div class="d-flex flex-row align-items-center mb-2">
          <img
            *ngIf="extraMealDetails?.duration"
            src="/assets/icons/clock.svg"
            alt="time"
          />
          &nbsp;
          <span class="primary-font-normal f-14 text-gray-800">
            Preparation time:&nbsp;
          </span>
          <span
            *ngIf="extraMealDetails?.duration"
            class="primary-font-bold f-14"
          >
            {{ extraMealDetails?.duration }} minutes
          </span>
        </div>

        <p
          *ngIf="extraMealDetails?.description"
          class="f-14 primary-font-normal text-gray-800 mb-2"
        >
          {{ extraMealDetails?.description }}
        </p>

        <span *ngIf="extraMealDetails?.price" class="primary-font-bold f-14">
          {{ extraMealDetails?.price | currency : '₦' }}
        </span>
      </div>
    </div>

    <div
      *ngIf="extraMealDetails !== null && extraMealDetails?.addOns"
      class="col-md-12 px-0 pb-3"
    >
      <div class="form-fields">
        <ng-container *ngFor="let item of extraMealDetails?.addOns">
          <div *ngFor="let addOn of item | keyvalue">
            <div *ngIf="isArray(addOn?.value)" class="pb-2 pt-2 pr-2 pl-4">
              <div
                class="d-flex flex-row justify-content-between align-items-center"
              >
                <p
                  *ngIf="isArray(addOn?.value)"
                  class="primary-font-normal my-2 f-13 lh-16 text-gray-500 text-uppercase"
                  [id]="createLocationId(addOn?.key)"
                >
                  {{ addOn?.key }}
                </p>
                <p class="mb-0">
                  <span
                    *ngIf="item?.isRequired && !showRequiredBadge(item)"
                    class="f-12 badge badge-pill primary-font-normal badge-required"
                  >
                    Required
                  </span>
                  <!-- <span
                    *ngIf="item?.select"
                    class="f-12 ml-2 badge primary-font-normal badge-pill badge-select"
                  >
                    Select {{ item?.select }}
                  </span> -->
                </p>
              </div>
            </div>
            <div *ngIf="isArray(addOn?.value)" class="section-padding">
              <div class="w-100 d-flex flex-row align-items-start">
                <div
                  role="listbox"
                  aria-orientation="vertical"
                  aria-labelledby="password-strength-options"
                  aria-roledescription="password-strength-options"
                  class="w-100"
                >
                  <ng-container *ngFor="let option of addOn?.value">
                    <ng-container>
                      <div
                        class="flex-row d-flex justify-content-between align-items-center"
                        [ngStyle]="{
                          opacity:
                            parseCount(option?.stockCount) > 0 ? '1' : '0.4'
                        }"
                      >
                        <ul>
                          <li
                            role="option"
                            [attr.aria-selected]="option?.name"
                            attr.aria-label="Selected {{ option?.name }}"
                            class="mt-2"
                            *ngIf="parseCount(option?.stockCount) > 0"
                          >
                            <label [for]="option.name">
                              <input
                                type="checkbox"
                                class="check-custom"
                                [name]="option?.name"
                                [value]="option?.name"
                                [id]="option?.name"
                                (change)="
                                  selectAddOn($event, option, addOn?.key)
                                "
                                [checked]="
                                  selectedAddOnNames?.indexOf(option?.name) >= 0
                                "
                              />
                              <span class="check-toggle"></span>
                              {{ option?.name }}
                            </label>
                          </li>
                          <li
                            (click)="notifyNoStock()"
                            class="mt-2"
                            *ngIf="parseCount(option?.stockCount) === 0"
                          >
                            {{ option?.name }}
                          </li>
                        </ul>
                        <p
                          *ngIf="option?.price"
                          class="primary-font-normal f-14"
                        >
                          {{ option?.price | currency : '₦' }}
                        </p>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="col-md-12 p-3 mx-3">
      <div class="d-flex flex-row gap-2">
        <div
          class="counter-prop d-flex flex-row justify-content-around align-items-center"
        >
          <button
            *ngIf="data && data?.quantityOrdered"
            type="button"
            class="btn border-0 p-0 f-18"
            [disabled]="data?.quantityOrdered && data?.quantityOrdered === 0"
            (click)="changeMealQuantity('decrease')"
          >
            &#8722;
          </button>
          <button
            *ngIf="data && !data?.quantityOrdered"
            type="button"
            class="btn border-0 p-0 f-18"
            [disabled]="chosenQuantity === 0"
            (click)="changeMealQuantity('decrease')"
          >
            &#8722;
          </button>
          <span
            *ngIf="data && data?.quantityOrdered; else showChosenQuantity"
            class="count secondary-font-normal f-14"
          >
            {{ data?.quantityOrdered }}
          </span>
          <ng-template #showChosenQuantity>
            <span class="count secondary-font-normal f-14">
              {{ chosenQuantity }}
            </span>
          </ng-template>
          <button
            type="button"
            class="btn border-0 p-0 f-18"
            [disabled]="
              chosenQuantity === extraMealDetails?.stockCount ||
              (data?.quantityOrdered &&
                data?.quantityOrdered === extraMealDetails?.stockCount)
            "
            (click)="changeMealQuantity('increase')"
          >
            &#43;
          </button>
        </div>
        <button
          type="submit"
          class="btn-add-item btn btn-dark f-14 primary-font-normal"
          [disabled]="chosenQuantity === 0 && !data?.quantityOrdered"
        >
          {{
            data?.source && data?.source === 'for-update'
              ? 'Update item'
              : 'Add item'
          }}
        </button>
      </div>
    </div>
  </form>
</div>
